export function shouldDisplay(isValid, isComplete) {
  return isValid && !isComplete
}
